import React, { useEffect, useState } from 'react';
import { eventTracker } from '../../../utils/EventTracker';
import { __ } from '../../../utils/translation-service';
import {
    CallUsButton,
    CallUsNumber,
    CallUsTitle,
    Container,
    StyledPhoneIcon,
    TitleWrapper,
} from './call-us-footer.style';

interface Props {
    phoneNumber: string;
    pageType: string;
}

export const CallUsFooter = ({ phoneNumber, pageType }: Props) => {
    const [url, setUrl] = useState('');

    const handleClick = () => {
        eventTracker.ga4Track('call_us_banner', {
            page_type: pageType,
            page_url: url,
        });
    };

    useEffect(() => {
        setUrl(window.location.href);
    }, [pageType]);

    return (
        <Container>
            <CallUsButton onClick={handleClick} href={`tel:${phoneNumber}`}>
                <StyledPhoneIcon width={20} height={20} />

                <TitleWrapper>
                    <CallUsTitle>{__('callustitle')}</CallUsTitle>

                    <CallUsNumber>{phoneNumber}</CallUsNumber>
                </TitleWrapper>
            </CallUsButton>
        </Container>
    );
};
